import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import './ToggleButton.less';

const ToggleButton = ({
  active,
  icon,
  iconWidth,
  label,
  subLabel,
  onClick,
  onHover,
  value,
  disabled,
  type,
  tooltipMessage,
  narrow, // * TODO: delete after PDP 2.0 is launched
}) => {
  function ToggleClick() {
    return disabled ? null : onClick({ type, label, value });
  }

  return (
    <div data-tooltip={disabled ? tooltipMessage : null} className="no-tooltip-on-mobile">
      <button
        type="button"
        aria-pressed={active}
        onClick={ToggleClick}
        onMouseEnter={() => onHover(value)}
        onMouseLeave={() => onHover(null)}
        className={cx(
          'pdp-toggle-button no-tooltip-on-mobile',
          {
            'pdp-toggle-button--active': active,
            'pdp-toggle-button--disabled': disabled,
          },
          {
            'pdp-toggle-button--narrow': narrow,
          }
        )}
      >
        {icon ? (
          <img
            src={icon}
            alt={label}
            className={cx('pdp-toggle-button-icon zolaicon')}
            style={iconWidth ? { width: iconWidth } : {}}
          />
        ) : null}
        <div
          className={cx('pdp-toggle-button-label', { 'pdp-toggle-button-label--active': active })}
        >
          <span>{label}</span>
          {subLabel ? (
            <span
              className={cx('pdp-toggle-button-sublabel', {
                'pdp-toggle-button-sublabel--active': active,
                'pdp-toggle-button-sublabel--disabled': disabled,
              })}
            >{`(${subLabel})`}</span>
          ) : null}
        </div>
      </button>
    </div>
  );
};

ToggleButton.propTypes = {
  active: PropTypes.bool,
  disabled: PropTypes.bool,
  icon: PropTypes.string,
  iconWidth: PropTypes.string,
  label: PropTypes.string.isRequired,
  subLabel: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onClick: PropTypes.func,
  onHover: PropTypes.func,
  tooltipMessage: PropTypes.string,
  narrow: PropTypes.bool,
};

ToggleButton.defaultProps = {
  active: false,
  disabled: false,
  onClick: () => {},
  onHover: () => {},
  narrow: false,
};

export default ToggleButton;



// WEBPACK FOOTER //
// ./src/cards/components/CardDetail/ToggleButton/ToggleButton.jsx